<template>
  <div class="inter-wrapper">
    <div class="orderinit-area">
      <div class="social_area">
        <div class="logintop" />
        <div class="social_btn_area text-center">
          <div class="inner_btn_area">
            <span class="title">
              {{ $langt('即買即用電子票券，輕鬆享受吃玩買住行') }}
            </span>
            <span class="subtitle">
              {{ $langt('轉址至台哥大會員登入中') }}...
            </span>
          </div>
          <img
            v-if="logo"
            class="bottonarea"
            :src="logo"
            width="100px"
            height="30px"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTwmOauthUrl } from '@/utils/tool'

export default {
  name: 'TwmSSO',
  data() {
    return {
      redirecturl: null,
      logo: ''
    }
  },
  created() {
    // 顯示 logo //
    if (
      this.$store.getters.shopInfo &&
      this.$store.getters.shopInfo.logo !== undefined
    ) {
      this.logo = this.$store.getters.shopInfo.logo2
    }
    this.redirecturl = this.$route.params.redirect
      ? window.atob(this.$route.params.redirect)
      : '/index'
    this.$nextTick(async() => {
      var url = new URL(getTwmOauthUrl())
      if (url.searchParams.has('redirect_uri')) {
        url.searchParams.set('redirect_uri', url.searchParams.get('redirect_uri') + '?to=' + this.redirecturl)
      }
      window.location.replace(url.toString())
    })
  }
}
</script>
<style scoped lang="scss">
@import 'assets/scss/common.scss';
.orderinit-area {
  min-height: 100vh;
  .social_area {
    padding: 0 !important;
    position: relative;
    .logintop {
      width: 100%;
      height: 400px;
      background: url(~@/assets/images/loginbgimg.svg) no-repeat bottom;
      background-size: cover;
      position: relative;
    }
    .social_btn_area {
      height: calc(100vh - 400px);
      // height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;
      & > * {
        margin: 0.5rem auto;
      }
      .inner_btn_area {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-items: stretch;
        flex: 3;
        .title {
          margin: 4px 0;
          font-weight: 600;
          font-size: 1rem;
          color: #6a6a6a;
        }
        .subtitle {
          margin: 4px 0;
          margin-top: 0.3rem;
          font-size: 0.7rem;
          color: rgba(#6a6a6a, 0.7);
          font-weight: 600;
        }
        .socialbtn {
          width: 280px;
          height: auto;
          margin: 6px auto;
          border-radius: 50px;
          border: 1px solid rgba($black-color, 0.2);
          background-color: $white-color;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.6s;
          &:hover {
            background-color: rgba(#e9e7e7, 0.8);
            cursor: pointer;
          }
        }
      }
      .bottonarea {
        flex: 1;
      }
    }
  }
}

.orderinit-area > .social_area:last-child {
  padding-bottom: 3.5rem;
}

@media screen and (min-width: 768px) {
  .orderinit-area {
    .social_area {
      .logintop {
        height: 650px;
      }
      .social_btn_area {
        height: 100%;
        margin-bottom: 5rem;
        & > * {
          margin: 1rem auto;
        }
        .inner_btn_area {
          .title {
            font-size: 1.2rem;
            font-weight: 600;
          }
          .subtitle {
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}
</style>
